module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice"
  }, [_c('off-canvas', {
    attrs: {
      "menu_pages": _vm.menu,
      "title": _vm.title,
      "action": _vm.action,
      "user": _vm.user
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54d43952!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Backoffice.vue
// module id = 2489
// module chunks = 1